import { StatusCircle } from '@/app/components'
import { DeviceType } from '@/app/components/DeviceSelectionGallery/DeviceSelectionGallery.types'
import { CardActionButton, CardActions, Modal, Text } from '@/components'
import { useAppSelector } from '@/hooks'
import { selectNextDeviceDREvent } from '@/selectors/vehicleDemandResponseEvent/selectNextVehicleDREvent'
import { ID } from '@/types/model'
import { getDateFromTimestamp } from '@/utils/timeUtilities'

type Props = {
  open: boolean
  onClose: () => void
  deviceId: ID
  deviceType: DeviceType
}

export default function VehicleDREventOptInConfirmationModal({
  open,
  onClose,
  deviceId,
  deviceType,
}: Props) {
  const event = useAppSelector((state) =>
    selectNextDeviceDREvent(state, deviceId, deviceType),
  )

  const eventTime = event?.start_datetime
    ? `${getDateFromTimestamp(
        event.start_datetime,
        'h:mm A',
      )} to ${getDateFromTimestamp(event.end_datetime, 'h:mm A')}`
    : 'unknown'

  return (
    <Modal
      id="vehicle-dr-event-opt-in-confirmation-modal"
      open={open}
      onClose={onClose}
    >
      <div className="flex flex-col items-center p-4 text-center">
        <StatusCircle status="succeeded" />
        <Text variant="h3" className="mt-4 font-bold">
          You rock! Thanks for participating in this event.
        </Text>
        <Text variant="body4" className="my-4 text-gray-600">
          This event runs between {eventTime} tonight. Your EV charging will be
          paused during this event if you decide to participate.
        </Text>

        <div className="w-full mt-2">
          <CardActions>
            <CardActionButton
              id="vehicle-dr-event-opt-in-done-button"
              type="primary"
              onClick={onClose}
            >
              Close
            </CardActionButton>
          </CardActions>
        </div>
      </div>
    </Modal>
  )
}
